const About=()=>{
    return (
        <div className="about">
            <h1>About us</h1>
            <h2>Our app delivers the food across the city with a no delivery charge for orders above Rs200 </h2>
        </div>
    )
}

export default About;